import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    title: 'Consagración',
    desc: 'Saneas tu corazón y pides perdón por las faltas cometidas bajo tu techo.'
  }, {
    title: 'Unción',
    desc: 'Recorres tu casa marcando los límites espirituales con fe y aceite bendito.'
  }, {
    title: 'Establecimiento',
    desc: 'Creas un nuevo lenguaje de amor que mantiene el muro de fuego encendido.'
  }];
  return <section className="py-24 px-6 bg-white" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <FadeIn data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center text-brown-900" data-id="element-111">
            Cómo funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-112">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-gold-200 -z-10" data-id="element-113" />

            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative text-center" data-id="element-114">
                <div className="w-16 h-16 mx-auto bg-gold-500 text-white rounded-full flex items-center justify-center text-2xl font-serif font-bold mb-6 shadow-lg ring-4 ring-white" data-id="element-115">
                  {index + 1}
                </div>
                <h3 className="text-2xl font-bold text-brown-900 mb-4 font-serif" data-id="element-116">
                  {step.title}
                </h3>
                <p className="text-lg text-brown-800" data-id="element-117">{step.desc}</p>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}